import {Injectable} from '@angular/core';
import {IoService} from './io.service';
import {Page} from '../models';

@Injectable()
export class PageService extends IoService {
  protected model = Page;
  protected listUrl = '/pages/';
}
